<template>
  <div class="about">
    <p></p>
    <b-jumbotron>
      <h1>The idea behind psos</h1>
      <p>
        At some point the modern microbiologist - analyzing genome,
        transcriptome or proteome data - reaches the point where an interesting
        protein lacks sufficient annotation, usually depicted by being a
        'hypothetical protein'. The following steps usually include a deeper
        characterization of the protein, which involves running several
        bioinformatics tools (either from the command line or by submitting the
        sequences to an online tool) and collecting their respective results.
        This is the moment where psos can support the researcher by offering a
        uniform interface for many amino acid based analysis tools. In its
        simplest form the application that displays the annotation has an
        'Analyze with psos' button and automatically sends the data to psos. It
        will analyze the data and display the results of all executed tools in a
        web frontend. As the tools have different runtimes, psos will display
        each tool result as soon as it is available.
      </p>
    </b-jumbotron>
    <b-jumbotron>
      <h1>Included analyses</h1>
      <p>
        Psos uses psot (protein sequence observation tool) for the analysis of
        protein sequences. Psot implements several analysis profiles for
        different use cases. Currently the following profiles are available:
      </p>
      <ul>
        <li>
          <strong>Bacteria-gram+</strong>
          <ul>
            <li>
              Homology search against swissprot
            </li>
            <li>
              homology search against Pfam-A
            </li>
            <li>
              signal peptide prediction
            </li>
            <li>
              transmembrane protein prediction
            </li>
          </ul>
        </li>
        <li>
          <strong>Bacteria-gram-</strong>
          <ul>
            <li>
              Homology search against swissprot
            </li>
            <li>
              homology search against Pfam-A
            </li>
            <li>
              signal peptide prediction
            </li>
            <li>
              transmembrane protein prediction
            </li>
          </ul>
        </li>
        <li>
          <strong>Eukaryote</strong>
          <ul>
            <li>
              Homology search against swissprot
            </li>
            <li>
              homology search against Pfam-A
            </li>
            <li>
              signal peptide prediction
            </li>
            <li>
              transmembrane protein prediction
            </li>
            <li>cellular localization prediction</li>
          </ul>
        </li>
        <li>
          <strong>Plant</strong>
          <ul>
            <li>
              Homology search against swissprot
            </li>
            <li>
              homology search against Pfam-A
            </li>
            <li>
              signal peptide prediction
            </li>
            <li>
              transmembrane protein prediction
            </li>
            <li>cellular localization prediction</li>
          </ul>
        </li>
      </ul>
    </b-jumbotron>
    <b-jumbotron>
      <h1>About psov</h1>

      <p>
        Psos is the product of multiple components. Each component fullfills one
        specific task, namely:
      </p>
      <ul>
        <li>
          <strong>dbxref</strong> - Resolve, retrieve and normalize database
          cross references (commandline tool)
        </li>
        <li>
          <strong>psot</strong> - Analyse protein sequences with analysis
          profiles (commandline tool)
        </li>
        <li><strong>dbxref-rest</strong> - Rest service for dbxref</li>
        <li>
          <strong>psos-rest</strong> - Microservice based rest service for
          scheduling psot jobs
        </li>
        <li><strong>psov</strong> - Visualization of psos results</li>
        <li>
          <strong>psov2</strong> - This website and visualization of psos
          results
        </li>
      </ul>

      <p>
        These tools are based on these open source technologies: python, java,
        javascript, nextflow, vert.x, biojs, d3, antlr4, vue.js, bootstrap and
        all bioinformatic tools and databases that are used.
      </p>
    </b-jumbotron>
  </div>
</template>
<script>
import Layout from "@/mixins/public-layout.vue";

export default {
  mixins: [Layout]
};
</script>
